import { url } from '../axios'

// const fetchImages = (endpoint, imageName) => {
const fetchImages = (imageName) => {
  if (!imageName) return ''
  return `${url}${imageName}`
}

export default fetchImages
